import React from 'react';
import styled from 'styled-components';
import ChevRightSvg from '../../images/chevron-right.inline.svg';
import Link from '../Link';

const ReccentPostWidget = styled.div`
	border-bottom: 1px solid #ced8e1;
	margin-bottom: 35px;
	padding-bottom: 40px;
`;
const RecentPostTitle = styled.h4`
	color: #19214b;
	font-weight: 700;
	font-size: 16px;
	margin: 0 0 15px 0;
`;
const List = styled.div``;
const ListItem = styled.div`
	margin-bottom: 9px;
	&:last-child {
		margin-bottom: 0;
	}
	> a {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		color: #99aabbef;
		font-weight: 500;
		transition: all 0.3s ease-in-out 0s;
		text-decoration: none;

		> div {
			border: 1px solid transparent;
			border-radius: 50%;
			width: 27px;
			height: 27px;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.3s ease-in-out 0s;
			margin-left: 8px;

			> div {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 90%;
				height: 90%;
				border-radius: 50%;

				> svg {
					width: 15px;
					height: 15px;
				}
			}
		}

		> div {
			min-width: 27px;
		}
		
		&:hover {
			color: #661271;

			> div {
				background-image: linear-gradient(90deg, #661271 100%, #5a35f2 0%);		
				
				> div {
					background-color: #fff;
				}
			}
		}
	}
`;

const ChevRight = styled.img``;

export default function TopPosts({ topPosts }) {
	if (!topPosts) {
		return null;
	}
	return (
		<ReccentPostWidget>
			<RecentPostTitle>Top Posts</RecentPostTitle>
			<List>
				{topPosts.map(({ node }) => {
					return (
						<ListItem key={node.id}>
							<Link noPrefetch to={`/${node.slug}/`}>
								<span>{node.title}</span>
								<div>
									<div>
										<ChevRight src={ChevRightSvg}/>
									</div>
								</div>
							</Link>
						</ListItem>
					);
				})}
			</List>
		</ReccentPostWidget>
	);
}
